import React from "react";

// Official Maqam logo. Never redesign or recreate it.
// variant: "full" (lantern + wordmark) — the provided asset is the full lockup.
export const LogoMark = ({ className = "h-9", onLight = false }) => (
  <img
    src="/maqam-logo.png"
    alt="Maqam"
    className={`${className} w-auto object-contain select-none`}
    draggable={false}
  />
);

// Small wordmark fallback used where the image would be too small to read.
export const WordMark = ({ className = "" }) => (
  <span className={`font-display font-bold tracking-tight ${className}`}>
    MAQAM <span className="font-normal">Journey</span>
  </span>
);
